import React, { useContext } from 'react';
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import { ChangeLanguageComponent } from './ChangeLanguage';
import { Widths } from '../utils/Enums/Common';
import { SideBarContext } from '../context/SideBarContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ImpersonationBanner } from './ImpersonationBanner';

interface HeaderProps {
    title: string;
}
export const Header = ({ title }: HeaderProps) => {
    const { sideBarVissible, setSideBarVissible } = useContext(SideBarContext);
    const languages = ['en', 'bg'];
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    const { logOut } = useContext(AuthContext);
    const navigate = useNavigate();

    const userName = localStorage.getItem('username') || '';
    const screenWidth = window.innerWidth;
    return (
        <>
            <div className='shadow d-flex flex-wrap justify-content-between align-items-center w-100 ps-4 pe-2 py-2 bg-white border-bottom '>
                <div className='d-flex'>
                    {!sideBarVissible && (
                        <Button
                            onClick={() => {
                                setSideBarVissible(true);
                            }}
                            className='bg-secondary me-2'
                            size='sm'
                        >
                            <FontAwesomeIcon icon={faBars} />
                        </Button>
                    )}

                    <h2 className='ps-2 mb-0'>{title}</h2>
                </div>
                <div className='d-flex align-items-center'>
                    <ChangeLanguageComponent languages={languages} />
                    {screenWidth > Widths.smallScreen && (
                        <h5 className='mb-0 px-3 w-100 text-nowrap'>
                            {t('welcome')}, {userName.length > 7 ? `${userName.slice(0, 7)}..` : userName}!
                        </h5>
                    )}

                    <Button
                        variant='outline-primary color-main'
                        size='sm'
                        onClick={() => {
                            logOut();
                            navigate('/login', { replace: true });
                        }}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} className='fa-fw' rotation={180} />
                    </Button>
                </div>
            </div>
            <ImpersonationBanner />
        </>
    );
};
